<script>
import { useI18n } from 'vue-i18n';
import {log} from "@/utils/clientLogger.js";

export default {
  name: "RegisterPage",
  data() {
    return {
      username: "",
      password: "",
      password_confirmation: "",
      role: "user",
      is_admin: null
    };
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  methods: {
    register() {
      const data = {
        username: this.username,
        password: this.password,
        role: this.role,
        is_admin: this.is_admin
      };
      this.$store.dispatch('register', data)
        .then(() => this.$router.push('/'))
          .catch(err => log.error('View:RegisterPage:register', {'error': err}));
    }
  }
};
</script>

<template>
  <div class="row align-items-center justify-content-center h-50">
    <h1 class="col-12">{{ t('auth.registerTitle') }}</h1>
    <form @submit.prevent="register" class="col-md-4">
      <label for="username" class="form-label">{{ t('auth.yourLoginLabel') }}</label>
      <div class="input-group mb-3">
        <span class="input-group-text" id="username">@</span>
        <input
          type="text"
          v-model="username"
          class="form-control"
          :placeholder="t('auth.usernamePlaceholder')"
          aria-label="Username"
          aria-describedby="username"
        />
      </div>

      <div class="input-group mb-3">
        <span class="input-group-text">{{ t('auth.yourPasswordLabel') }}</span>
        <input
          type="password"
          v-model="password"
          class="form-control"
          :placeholder="t('auth.passwordCreatePlaceholder')"
          aria-label="Password"
        />
      </div>

      <div class="input-group mb-3">
        <span class="input-group-text">{{ t('auth.passwordConfirmLabel') }}</span>
        <input
          type="password"
          v-model="password_confirmation"
          class="form-control"
          :placeholder="t('auth.passwordConfirmPlaceholder')"
          aria-label="ConfirmPassword"
        />
      </div>

      <button type="submit" class="btn btn-success w-50 mx-auto">{{ t('auth.registerButton') }}</button>
    </form>
  </div>
</template>

<style scoped lang="scss">
/* Add styling as needed */
</style>